import { useContext, createContext } from 'react';

import { APIConfigContextProps } from '../types';

// ----------------------------------------------------------------------

export const APIConfigContext = createContext({} as APIConfigContextProps);

export const useAPIConfigContext = () => {
  const context = useContext(APIConfigContext);

  if (!context) throw new Error('useAPIConfigContext error');

  return context;
};
